import { Component } from '@angular/core';

@Component({
  selector: 'portal-erfolg-1-svg',
  standalone: true,
  templateUrl: './erfolg-1.component.svg',
  styleUrl: './erfolg-1.component.scss',
})
export class Erfolg1SvgComponent {}
